<template>
  <div class="clutch d-flex flex-column align-items-start align-items-lg-center justify-content-center gap-1 gap-md-2 group">
    <div class="ms-n1 ms-md-0">
      <!-- Replace this placeholder SVG with your actual Clutch logo SVG -->
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="93"
          height="31"
          viewBox="0 0 93 31"
          fill="none"
          className="w-[60px] lg:w-[93px] h-[20px] lg:h-[31px]"
        >
          <path
            d="M25.4375 3.70898H29.3524V27.8789H25.4375V3.70898Z"
            fill="white"
          />
          <path
            d="M42.9733 20.2198C42.9733 23.9645 39.9095 24.3049 38.8882 24.3049C36.5053 24.3049 36.1649 22.0921 36.1649 20.9007V11.5391H32.25V20.7305C32.25 22.9432 32.9308 24.9857 34.2925 26.1772C35.484 27.3687 37.0159 27.8793 38.8882 27.8793C40.2499 27.8793 41.952 27.5389 42.9733 26.5176V27.8793H46.8881V11.5391H42.9733V20.2198Z"
            fill="white"
          />
          <path
            d="M54.5428 5.58203H50.628V11.5394H47.7344V15.2841H50.628V27.8797H54.5428V15.2841H57.4364V11.5394H54.5428V5.58203Z"
            fill="white"
          />
          <path
            d="M69.6993 22.9438C68.8483 23.6246 67.6568 24.1352 66.4653 24.1352C63.742 24.1352 61.8696 22.0927 61.8696 19.3693C61.8696 16.646 63.742 14.7736 66.4653 14.7736C67.6568 14.7736 68.8483 15.1141 69.6993 15.9651L70.21 16.4758L72.9334 13.9226L72.2525 13.412C70.7206 12.0503 68.6781 11.1992 66.4653 11.1992C61.6994 11.1992 58.125 14.7736 58.125 19.5396C58.125 24.3055 61.6994 27.8799 66.4653 27.8799C68.6781 27.8799 70.7206 27.0288 72.2525 25.6672L72.9334 25.1565L70.21 22.4331L69.6993 22.9438Z"
            fill="white"
          />
          <path
            d="M86.7116 12.9004C85.5202 11.7089 84.3287 11.1983 82.4564 11.1983C81.0947 11.1983 79.733 11.5387 78.7117 12.56V3.70898H74.7969V27.8789H78.7117V18.8578C78.7117 15.1131 81.2649 14.7727 82.2862 14.7727C84.6691 14.7727 84.4989 16.9854 84.4989 18.1769V27.7087H88.4138V18.3471C88.4138 16.1344 87.9031 14.0919 86.7116 12.9004Z"
            fill="white"
          />
          <path
            d="M66.2937 22.2632C67.7978 22.2632 69.0171 21.0439 69.0171 19.5398C69.0171 18.0357 67.7978 16.8164 66.2937 16.8164C64.7896 16.8164 63.5703 18.0357 63.5703 19.5398C63.5703 21.0439 64.7896 22.2632 66.2937 22.2632Z"
            fill="#FF3B3B"
          />
          <path
            d="M19.9932 21.9223C18.6315 23.284 16.589 24.135 14.3762 24.135C10.1209 24.135 7.05714 20.7308 7.05714 16.1351C7.05714 11.5394 10.1209 8.13521 14.5464 8.13521C16.589 8.13521 18.6315 8.98626 20.1634 10.5182L20.674 11.0288L23.2272 8.47563L22.7166 7.96499C20.5038 5.75225 17.6102 4.56077 14.5464 4.56077C8.07841 4.39056 3.3125 9.49689 3.3125 16.1351C3.3125 22.7733 8.07841 27.8797 14.3762 27.8797C17.44 27.8797 20.5038 26.6882 22.5463 24.4755L23.057 23.9648L20.5038 21.4117L19.9932 21.9223Z"
            fill="white"
          />
        </svg>
    </div>

    <div class="w-100 d-flex align-items-center justify-content-center gap-1 overflow-visible">
      <p class="small text-white-90 mb-0">Read reviews</p>
      <i class="bi bi-arrow-up-right text-white small ms-1 arrow-icon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "Clutch",
};
</script>

<style scoped>
.clutch {
  transition: all 0.3s ease-in-out;
}

.logo-svg {
  width: 60px;
  height: 20px;
}

@media (min-width: 992px) {
  .logo-svg {
    width: 93px;
    height: 31px;
  }
}

.arrow-icon {
  transform: translateX(-10px);
  opacity: 0;
  transition: all 0.3s ease;
}

.clutch:hover .arrow-icon {
  transform: translateX(0);
  opacity: 1;
}
</style>
